import moment from "moment";
import { useCallback } from "react";
import { addR, delR, getRowKey } from "../../../../utils/helpers";
import { CONDITIONS_MI_COLUMNS } from "../../../../utils/constants";
import { DataGrid, GridActionsCellItem } from "@mui/x-data-grid";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus, faTrash } from "@fortawesome/free-solid-svg-icons";
import { esES } from "@mui/x-data-grid/locales";
import { esES as pickersEsES } from "@mui/x-date-pickers/locales";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import styles from "../styles.module.css";
import Button from "../../../../components/button";

export const CondTable = (data) => {
  let tabName = data.tablekey;
  let tabdata = data.fulldata[tabName];
  let setCondData = data.setter;
  let nuDtime = moment(data.month, "MMMM YYYY").format("yyyy-MM-DD");
  let condData = data.fulldata;

  const deleteEntry = useCallback(
    (params, setCondData, tabName) => () => {
      setTimeout(() => {
        setCondData((oldRows) => delR(oldRows, tabName, params.row.id));
      });
    },
    []
  );

  const handleProcessRowUpdateError = useCallback((error) => {
    console.log({ children: error.message, severity: "error" });
  }, []);

  const processRowUpdate = useCallback(
    async (nuRow, oldRow, condData, setCondData, tabName) => {
      let idx = condData[tabName].findIndex((obj) => obj?.id === nuRow.id);
      let nuData = { ...condData };
      let nutab = [...condData[tabName]];

      nutab[idx] = { ...nuRow };
      nuData[tabName] = nutab;

      setCondData(nuData);

      return { ...nuRow };
    },
    []
  );

  const miColumns = {
    ...CONDITIONS_MI_COLUMNS,
    actions: [
      {
        field: "actions",
        type: "actions",
        width: 20,
        getActions: (params) => [
          <GridActionsCellItem
            icon={<FontAwesomeIcon icon={faTrash} />}
            label="Delete"
            title="eliminar fila"
            onClick={deleteEntry(params, setCondData, tabName)}
          />,
        ],
        renderHeader: () => (
          <div>
            <Button
              title="Añadir fila"
              variant="ghost"
              size="small"
              onClick={() => {
                setCondData((oldRows) => addR(oldRows, tabName, nuDtime));
              }}
            >
              <FontAwesomeIcon icon={faPlus} />
            </Button>
          </div>
        ),
      },
    ],
  };

  const dgminwidth = tabName === "mmconditions" ? "10px" : "auto";
  const dgheadersize = tabName === "mmconditions" ? 80 : 52;
  return (
    <div
      className={`inline-block overflow-x-auto min-w-1 flex-col${
        tabName === "mmconditions" ? "max-w-full w-full " : ""
      }`}
    >
      <LocalizationProvider
        localeText={
          pickersEsES.components.MuiLocalizationProvider.defaultProps.localeText
        }
        dateAdapter={AdapterMoment}
        adapterLocale={"es"}
      >
        <DataGrid
          getRowId={(row) => getRowKey(tabName, row)}
          getRowClassName={(params) =>
            params.indexRelativeToCurrentPage % 2 === 0
              ? ""
              : styles.dataGridRowAlt
          }
          processRowUpdate={(newRow, oldRow) =>
            processRowUpdate(newRow, oldRow, condData, setCondData, tabName)
          }
          onProcessRowUpdateError={handleProcessRowUpdateError}
          rows={tabdata}
          columns={[...miColumns.actions, ...miColumns[tabName]]}
          hideFooterPagination
          hideFooterSelectedRowCount
          hideFooter
          localeText={esES.components.MuiDataGrid.defaultProps.localeText}
          rowLength={500}
          columnHeaderHeight={dgheadersize}
          sx={{
            maxHeight: "500",
            minHeight: "200",
            width: "auto", // Make the DataGrid width auto
            minWidth: dgminwidth, // Ensure it takes up full width if container is narrower
            "& .MuiDataGrid-virtualScroller": {
              overflowY: "auto", // Enable vertical scrolling for rows
              maxHeight: "80vh", // Limit height of the rows area (adjust as needed)
            },
            "& .MuiDataGrid-scrollbar--horizontal": {
              left: 0,
            },
            "& .MuiDataGrid-columnHeaderTitle": {
              whiteSpace: "normal",
              lineHeight: "normal",
            },
          }}
        />
      </LocalizationProvider>
    </div>
  );
};
